// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_SNT","cls2":"SimplePaperPodcast-cls2_TOm SimplePaperPodcast-cls1_SNT"};